import React from 'react';
import { Text } from '@carnica/ui-kit';
import { useIsMobileDimension } from '@beef/ui-kit';
import className from 'classnames/bind';
import styles from "./styles.pcss";
import { Metric } from "../../metric";
import { connector } from "./connector";
var cx = className.bind(styles);
export var _ClickableText = function _ClickableText(_ref) {
  var textBefore = _ref.textBefore,
    textAfter = _ref.textAfter,
    clickableTextEnd = _ref.clickableTextEnd,
    hrefEnd = _ref.hrefEnd,
    clickableText = _ref.clickableText,
    href = _ref.href,
    _onClick = _ref.onClick,
    _ref$textSize = _ref.textSize,
    textSize = _ref$textSize === void 0 ? '2xs' : _ref$textSize,
    theme = _ref.theme;
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement("div", {
    className: cx('content', "content-theme__".concat(theme)),
    "data-t-id": "components-ClickableText"
  }, textBefore && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    color: "tertiary",
    size: textSize,
    style: {
      display: 'inline'
    }
  }, textBefore), ' '), isMobile && /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: JSON.stringify({
      link_text: clickableText,
      link_url: href
    }),
    events: {
      shortFooterMetric: ['handleClickLink']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "primary",
    onClick: function onClick(e) {
      return _onClick(e, 'agreement');
    },
    role: "button",
    size: textSize,
    style: {
      display: 'inline',
      cursor: 'pointer'
    },
    tagName: "a",
    "data-t-id": "components-ClickableText"
  }, clickableText)), textAfter && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement(Text, {
    color: "tertiary",
    size: textSize,
    style: {
      display: 'inline'
    }
  }, textAfter)), clickableTextEnd && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: JSON.stringify({
      link_text: clickableTextEnd,
      link_url: hrefEnd
    }),
    events: {
      shortFooterMetric: ['handleClickLink']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "primary",
    onClick: function onClick(e) {
      return _onClick(e, 'instruction');
    },
    role: "button",
    size: textSize,
    style: {
      display: 'inline',
      cursor: 'pointer'
    },
    tagName: "a",
    "data-t-id": "components-ClickableText"
  }, clickableTextEnd))));
};
export var ClickableText = connector(_ClickableText);